
import type { SVGProps } from 'react';
const SvgLocationOn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={72}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#location-on_svg__a)">
      <path
        fill="#263E6A"
        d="M12 11.5a1.45 1.45 0 0 0 1.066-.434A1.45 1.45 0 0 0 13.5 10a1.45 1.45 0 0 0-.434-1.066A1.45 1.45 0 0 0 12 8.5a1.45 1.45 0 0 0-1.066.434A1.45 1.45 0 0 0 10.5 10q0 .633.434 1.066.433.435 1.066.434m0 8.754q3.128-2.723 4.814-5.453T18.5 10.2q0-2.955-1.882-4.828Q14.737 3.5 12 3.5T7.382 5.372Q5.5 7.244 5.5 10.2q0 1.87 1.687 4.601 1.686 2.73 4.813 5.453m0 1.361q-3.795-3.366-5.647-6.247T4.5 10.2q0-3.519 2.268-5.61Q9.036 2.5 12 2.5t5.232 2.09T19.5 10.2q0 2.289-1.853 5.168T12 21.615"
      />
    </g>
    <g clipPath="url(#location-on_svg__b)">
      <path
        fill="#263E6A"
        d="M60 11.963q.68 0 1.16-.497.48-.498.48-1.201t-.48-1.202A1.55 1.55 0 0 0 60 8.566q-.68 0-1.16.497-.48.498-.48 1.201 0 .705.48 1.202t1.16.497m.023 9.657a1 1 0 0 1-.304-.049.8.8 0 0 1-.258-.145q-3.492-3.179-5.227-5.896-1.734-2.718-1.734-5.071 0-3.64 2.262-5.8T60 2.5t5.238 2.16 2.262 5.799q0 2.353-1.734 5.07-1.735 2.719-5.227 5.897a.9.9 0 0 1-.246.146.8.8 0 0 1-.27.048"
      />
    </g>
    <defs>
      <clipPath id="location-on_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="location-on_svg__b">
        <path fill="#fff" d="M48 0h24v24H48z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLocationOn;
